import { BASE_URL } from 'constants/api';

import { stringify } from 'query-string';
import { createGetAllAPI } from '@cuemath/rest-api';

export const ACTIONS = {
  GET: 'LUMA_EVENTS_GET_ALL',
  GET_SUCCESS: 'LUMA_EVENTS_GET_ALL_SUCCESS',
  GET_FAILURE: 'LUMA_EVENTS_GET_ALL_FAILURE',
};

const {
  useGetAll: useGetAllLumaEvents,
  invalidate: invalidateLumaEvents,
} = createGetAllAPI({
  getURL: query => {
    return `${BASE_URL}/luma/events/?${stringify(query)}`;
  },
});

export { useGetAllLumaEvents, invalidateLumaEvents };
